export const PARTICIPANT_SELECTOR_TEXT_SEARCH_MIN_LENGTH = 2

function normalizeText(value) {
  return typeof value === 'string' ? value.trim() : ''
}

function hasSpecificText(value) {
  return normalizeText(value).length >= PARTICIPANT_SELECTOR_TEXT_SEARCH_MIN_LENGTH
}

export function normalizeParticipantSelectorFilter(filter = {}) {
  return {
    name: normalizeText(filter.name),
    surname: normalizeText(filter.surname),
    shortname: normalizeText(filter.shortname),
    groupname: normalizeText(filter.groupname),
    language: normalizeText(filter.language),
    device: normalizeText(filter.device),
  }
}

export function shouldUseRecursiveParticipantSearch(filter = {}) {
  const normalized = normalizeParticipantSelectorFilter(filter)

  return shouldSearchParticipants(normalized) || shouldSearchParticipantGroups(normalized)
}

export function shouldSearchParticipants(filter = {}) {
  const normalized = normalizeParticipantSelectorFilter(filter)

  return hasSpecificText(normalized.name)
    || hasSpecificText(normalized.surname)
    || hasSpecificText(normalized.shortname)
    || normalized.language.length > 0
    || normalized.device.length > 0
}

export function shouldSearchParticipantGroups(filter = {}) {
  return hasSpecificText(normalizeParticipantSelectorFilter(filter).groupname)
}
